import { Box, Link } from "@mui/material";
import TkModal from "../../../components/atoms/TkModal";
import TkTitle from "../../../components/atoms/TkTitle";
import TkFakeTable from "../../../components/molecules/TkFakeTable";
import { demanderUserType } from "../parts";
import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";
import { useState } from "react";

/**
 * 請求者登録モーダル
 * @param {any} props.item レスポンスデータ
 * @param {boolean} props.open true:開く false:閉じる
 * @param {any} props.button 対応ボタン
 * @param {any} props.onClose 「閉じる」ボタン押下時のイベント
 * @return ProcedureModal
 */
const ProcedureModal = (props: any) => {
  const { open, onClose, onOkey } = props;
  const [demanderTel, setDemanderTel] = useState("");

  const handleSubmit = (e: any, index?: number) => {
    console.log(index);
    if (index === 0) {
      onClose();
    } else if (index === 1) {
      onOkey({ ...e, demanderTel });
    }
  };

  const tableList = [
    {
      title: "請求者氏名",
      keyword: "demanderNameKanji",
      type: "name",
      requiredIcon: true,
    },
    {
      title: "請求者メールアドレス",
      keyword: "demanderEmail",
      type: "mail",
      requiredIcon: true,
    },
    {
      title: "請求者生年月日",
      keyword: "demanderBirthday",
      type: "date",
      requiredIcon: true,
      minDate: new Date("1900-01-01"),
      maxDate: new Date(),
    },
    {
      title: "請求者電話番号",
      keyword: "demanderTel",
      type: "phoneNum",
      requiredIcon: true,
      onGetInputValue: (e: any) => setDemanderTel(e.target.valueForShow),
    },
    {
      title: "請求者区分",
      keyword: "demanderUserType",
      type: "selectForm",
      requiredIcon: true,
      selectPropsList: demanderUserType,
    },
  ];

  const schema = {
    demanderNameKanji: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      pattern: {
        value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
        message: TkPropertyMessageGet("TKMSG_SCR0061E"),
      },
      maxLength: {
        value: 48,
        message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
      },
    },

    demanderEmail: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      pattern: {
        value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
        message: TkPropertyMessageGet("TKMSG_SCR0062E"),
      },
      maxLength: {
        value: 85,
        message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
      },
    },

    demanderBirthday: { required: TkPropertyMessageGet("TKMSG_SCR0043E") },

    demanderTel: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      pattern: {
        value: /^[0-9]*$/,
        message: TkPropertyMessageGet("TKMSG_SCR0053E"),
      },
      minLength: {
        value: 10,
        message: TkPropertyMessageGet("TKMSG_SCR0045E", "10"),
      },
      maxLength: {
        value: 19,
        message: TkPropertyMessageGet("TKMSG_SCR0046E", "21"),
      },
    },

    demanderUserType: { required: TkPropertyMessageGet("TKMSG_SCR0043E") },
  };

  return (
    <TkModal className="SCRC020001Components" open={open}>
      <Box className="modal">
        <TkTitle>登録</TkTitle>
        <TkFakeTable
          list={tableList}
          ruleSchema={schema}
          onCheckAndSubmit={(e, index) => handleSubmit(e, index)}
          submitButtonGroup={[
            {
              submitButtonText: "キャンセル",
              submitButtonDisabled: false,
              bypassValidation: true,
            },
            {
              submitButtonText: "登録",
              submitButtonDisabled: false,
            },
          ]}
        />
      </Box>
    </TkModal>
  );
};

export interface ITkInquiryTableListProps {
  title: string; // タイトル
  keyword: string; // key
  type?: "text" | "link"; // text: ラベル、 link: リンク
  text?: any; // 値
  onClick?: any; // リンククリック時のイベント
  color?: string; // 網掛け
  icon?: any; // アイコン
}
interface ITkInquiryTableProps {
  list: ITkInquiryTableListProps[][];
}

const TkInquiryTable: React.FC<ITkInquiryTableProps> = (props) => {
  const { list } = props;

  return (
    <Box className="tkInquiryTable">
      {list.map((item, index) => {
        if (!item.length) return <Box className="lineBreak" />;

        return (
          <Box
            className={`table ${item.length === 1 ? "single" : ""}`}
            key={index}
          >
            {item.map((d, i) => (
              <Box className="tableLine" key={`${index}-${i}`}>
                <Box className="tableTitle">
                  {d.title}
                  {d.icon && d.icon}
                </Box>

                <Box className="tableText" bgcolor={d.color ?? "#f7fafc"}>
                  {d.type === "link" ? (
                    <Link onClick={d.onClick}>{d.text}</Link>
                  ) : (
                    d.text
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        );
      })}
    </Box>
  );
};

export { ProcedureModal, TkInquiryTable };
